// Panel derecho — Lista de IEDs + Catálogo de típicos
import { useState } from "react";
import { useNbStore } from "../../store/nbStore";
import { usePagesStore } from "../../store/pagesStore";
import { cn } from "../../design-system/tokens";
import { useLangStore } from "../../store/langStore";
import { t as tr } from "../../lib/i18n";
import { SP_VIEWS, SP4_MODEL } from "../../lib/genericNodes";

const IED_CATALOG: Record<string, Record<string, string[]>> = {"SIEMENS SP5": {"dataset_Ln1": ["7SL82", "7SL86", "7SL87", "7SA82", "7SA86", "7SA87"], "dataset_PTS1": ["7UT82", "7UT85"], "dataset_Mt1": ["7SK82", "7SK85", "7UM85"], "dataset_VI3p1": ["7SJ81", "7SJ82", "7SJ85"]}, "ABB/HITACHI": {"dataset_620s": ["REF620", "REM620", "RET620", "RER620", "REF615", "REM615", "RET615", "RED615", "REC615", "REX640"], "dataset_670s": ["REL670", "RED670", "RET670", "REG670", "REC670"]}, "SEL": {"dataset_G02_SEL": ["SEL411L", "SEL421"], "dataset_G03_SEL": ["SEL700BT", "SEL700G"], "dataset_G04_SEL": ["SEL751", "SEL787L"], "dataset_G08_SEL": ["SEL451"], "dataset_G09_SEL": ["SEL487B"], "dataset_G10_SEL": ["SEL487E"]}, "GE MULTILIN": {"dataset_GE": ["Familia UR"]}};

// Plantillas de bahía (señales reales de los archivos Excel)
const BAHIA_LINEA       = [
  "Modo simulación IED",
  "Modo prueba IED",
  "Local remoto IED",
  "Arranque general",
  "Arranque de tiempo instántanea 50",
  "Arranque de sobrecorriente temporizada 51",
  "Arranque de tiempo instántanea de neutro 50N",
  "Arranque de sobrecorriente temporizada de neutro 51N",
  "Arranque 32 potencia direccional",
  "Arranque 67 direccional de fases",
  "Arranque 67N direccional de neutro",
  "Arranque 59 sobretensión",
  "Arranque 27 subtensión",
  "Arranque 87L diferencial de línea",
  "Arranque 21 direccional",
  "Arranque 21 direccional Z1",
  "Arranque 21 direccional Z2",
  "Arranque 21 direccional Z3",
  "Arranque 46 desbalance de corriente",
  "Arranque 81 subfrecuencia",
  "Arranque 81 sobrefrecuencia",
  "Disparo general",
  "Disparo de tiempo instántanea 50",
  "Disparo de sobrecorriente temporizada 51",
  "Disparo de tiempo instántanea 50N",
  "Disparo de sobrecorriente temporizada 51N",
  "Disparo 32 potencia direccional",
  "Disparo 67 direccional de fases",
  "Disparo 67N direccional de neutro",
  "Disparo 59 sobretensión",
  "Disparo 27 subtensión",
  "Recierre 79 habilitado",
  "Recierre 79 operando",
  "Falla sincronismo 25",
  "Disparo 87L diferencial de línea",
  "Disparo 21 direccional",
  "Disparo 21 direccional Z1",
  "Disparo 21 direccional Z2",
  "Disparo 21 direccional Z3",
  "Disparo 46 desbalance de corriente",
  "Disparo 81 subfrecuencia",
  "Disparo 81 sobrefrecuencia",
  "Disparo Falla interruptor etapa 1",
  "Disparo Falla interruptor etapa 2",
  "Posición de interruptor",
  "Posición de seccionador barra A",
  "Posición de seccionador barra B",
  "Posición de seccionador de línea",
  "Posición de cuchilla de puesta tierra",
  "Comando de interruptor",
  "Comando de seccionador barra A",
  "Comando de seccionador barra B",
  "Comando de seccionador de línea",
  "Enclavamiento de cierre interruptor",
  "Enclavamiento de apertura interruptor",
  "Enclavamiento de cierre seccionador de barra A",
  "Enclavamiento de apertura seccionador de barra A",
  "Enclavamiento de cierre seccionador de barra B",
  "Enclavamiento de apertura seccionador de barra B",
  "Enclavamiento de cierre seccionador línea",
  "Enclavamiento de apertura seccionador línea",
  "Falla circuito de disparo 1",
  "Falla circuito de disparo 2",
  "Corriente de fase A",
  "Corriente de fase B",
  "Corriente de fase C",
  "Tensión de línea AB",
  "Tensión de línea BC",
  "Tensión de línea CA",
  "Tensión de fase A",
  "Tensión de fase B",
  "Tensión de fase C",
  "Potencia activa trifásica",
  "Potencia reactiva trifásica",
  "Potencia aparente trifásica",
  "Factor de potencia trifásico",
];
const BAHIA_ACOPLE      = [
  "Arranque general",
  "Arranque tiempo instantánea 50",
  "Arranque sobrecorriente temporizada 51",
  "Arranque tiempo instantánea de neutro 50N",
  "Arranque sobrecorriente temporizada de neutro 51N",
  "Arranque 46 desbalance de corriente",
  "Arranque 59 sobretensión barra 1",
  "Arranque 59 sobretensión barra 2",
  "Arranque 27 subtensión barra 1",
  "Arranque 27 subtensión barra 2",
  "Arranque 81 subfrecuencia",
  "Arranque 81 sobrefrecuencia",
  "Arranque 25 falla de sincronismo",
  "Arranque 87B diferencial de barras",
  "Disparo general",
  "Disparo tiempo instantánea 50",
  "Disparo sobrecorriente temporizada 51",
  "Disparo tiempo instantánea de neutro 50N",
  "Disparo sobrecorriente temporizada de neutro 51N",
  "Disparo 46 desbalance de corriente",
  "Disparo 59 sobretensión barra 1",
  "Disparo 59 sobretensión barra 2",
  "Disparo 27 subtensión barra 1",
  "Disparo 27 subtensión barra 2",
  "Disparo 81 subfrecuencia",
  "Disparo 81 sobrefrecuencia",
  "Disparo 25 falla de sincronismo (bloqueo de cierre)",
  "Disparo 87B diferencial de barras",
  "Disparo falla de interruptor etapa 1 (50BF)",
  "Disparo falla de interruptor etapa 2 (50BF)",
  "Posición de interruptor",
  "Posición de seccionador barra A",
  "Posición de seccionador barra B",
  "Posición de seccionador de línea",
  "Posición de cuchilla de puesta a tierra",
  "Comando de interruptor",
  "Comando de seccionador barra A",
  "Comando de seccionador barra B",
  "Comando de seccionador de línea",
  "Enclavamiento de cierre interruptor",
  "Enclavamiento de apertura interruptor",
  "Enclavamiento de cierre seccionador barra A",
  "Enclavamiento de apertura seccionador barra A",
  "Enclavamiento de cierre seccionador barra B",
  "Enclavamiento de apertura seccionador barra B",
  "Enclavamiento de cierre seccionador línea",
  "Enclavamiento de apertura seccionador línea",
  "Falla circuito de disparo 1",
  "Falla circuito de disparo 2",
  "Corriente de fase A",
  "Corriente de fase B",
  "Corriente de fase C",
  "Corriente de secuencia cero",
  "Tensión de línea AB barra 1",
  "Tensión de línea BC barra 1",
  "Tensión de línea CA barra 1",
  "Tensión de línea AB barra 2",
  "Tensión de línea BC barra 2",
  "Tensión de línea CA barra 2",
  "Diferencia de tensión entre barras",
  "Potencia activa trifásica",
  "Potencia reactiva trifásica",
  "Potencia aparente trifásica",
  "Factor de potencia trifásico",
  "Frecuencia barra 1",
  "Frecuencia barra 2",
];
const BAHIA_TRANSFORMADOR = [
  "Modo simulación IED",
  "Modo prueba IED",
  "Local remoto IED",
  "Arranque general lado 1",
  "Arranque 87T diferencial de transformador lado 1",
  "Arranque de tiempo instántanea 50 lado 1",
  "Arranque de sobrecorriente temporizada 51 lado 1",
  "Arranque de tiempo instántanea de neutro 50N lado 1",
  "Arranque de sobrecorriente temporizada de neutro 51N lado 1",
  "Arranque 32 potencia direccional lado 1",
  "Arranque 59 sobretensión lado 1",
  "Arranque 27 subtensión lado 1",
  "Disparo general lado 1",
  "Disparo 87T diferencial de transformador lado 1",
  "Disparo de tiempo instántanea 50 lado 1",
  "Disparo de sobrecorriente temporizada 51 lado 1",
  "Disparo de tiempo instántanea de neutro 50N lado 1",
  "Disparo de sobrecorriente temporizada de neutro 51N lado 1",
  "Disparo 32 potencia direccional lado 1",
  "Disparo 59 sobretensión lado 1",
  "Disparo 27 subtensión lado 1",
  "Arranque general lado 2",
  "Arranque 87T diferencial de transformador lado 2",
  "Arranque de tiempo instántanea 50 lado 2",
  "Arranque de sobrecorriente temporizada 51 lado 2",
  "Arranque de tiempo instántanea de neutro 50N lado 2",
  "Arranque de sobrecorriente temporizada de neutro 51N lado 2",
  "Arranque 32 potencia direccional lado 2",
  "Arranque 59 sobretensión lado 2",
  "Arranque 27 subtensión lado 2",
  "Disparo general lado 2",
  "Disparo 87T diferencial de transformador lado 2",
  "Disparo de tiempo instántanea 50 lado 2",
  "Disparo de sobrecorriente temporizada 51 lado 2",
  "Disparo de tiempo instántanea de neutro 50N lado 2",
  "Disparo de sobrecorriente temporizada de neutro 51N lado 2",
  "Disparo 32 potencia direccional lado 2",
  "Disparo 59 sobretensión lado 2",
  "Disparo 27 subtensión lado 2",
  "Posición de interruptor lado 1",
  "Posición de seccionador lado 1",
  "Posición de interruptor lado 2",
  "Posición de seccionador lado 2",
  "Comando interruptor lado 1",
  "Comando seccionador lado 1",
  "Comando interruptor lado 2",
  "Comando seccionador lado 2",
  "Falla 25 sincronismo lado 1",
  "Falla 25 tiempo máximo lado 1",
  "Falla 25 sincronismo lado 2",
  "Falla 25 tiempo máximo lado 2",
  "Falla comunicación canal A",
  "Falla comunicación canal B",
  "Corriente de fase A lado 1",
  "Corriente de fase B lado 1",
  "Corriente de fase C lado 1",
  "Tensión de línea AB lado 1",
  "Tensión de línea BC lado 1",
  "Tensión de línea CA lado 1",
  "Tensión de fase A lado 1",
  "Tensión de fase B lado 1",
  "Tensión de fase C lado 1",
  "Potencia activa trifásica lado 1",
  "Potencia reactiva trifásica lado 1",
  "Potencia aparente trifásica lado 1",
  "Factor de potencia trifásico lado 1",
  "Corriente de fase A lado 2",
  "Corriente de fase B lado 2",
  "Corriente de fase C lado 2",
  "Tensión de línea AB lado 2",
  "Tensión de línea BC lado 2",
  "Tensión de línea CA lado 2",
  "Tensión de fase A lado 2",
  "Tensión de fase B lado 2",
  "Tensión de fase C lado 2",
  "Potencia activa trifásica lado 2",
  "Potencia reactiva trifásica lado 2",
  "Potencia aparente trifásica lado 2",
  "Factor de potencia trifásico lado 2",
];
const BAHIA_ALIMENTADOR = [
  "Modo simulación IED",
  "Modo prueba IED",
  "Local remoto IED",
  "Arranque general",
  "Arranque de tiempo instántanea 50",
  "Arranque de sobrecorriente temporizada 51",
  "Arranque de tiempo instántanea de neutro 50N",
  "Arranque de sobrecorriente temporizada de neutro 51N",
  "Arranque 32 potencia direccional",
  "Arranque 67 direccional de fases",
  "Arranque 67N direccional de neutro",
  "Arranque 59 sobretensión",
  "Arranque 27 subtensión",
  "Disparo general",
  "Disparo de tiempo instántanea 50",
  "Disparo de sobrecorriente temporizada 51",
  "Disparo de tiempo instántanea 50N",
  "Disparo de sobrecorriente temporizada 51N",
  "Disparo 32 potencia direccional",
  "Disparo 67 direccional de fases",
  "Disparo 67N direccional de neutro",
  "Disparo 59 sobretensión",
  "Disparo 27 subtensión",
  "Recierre 79 habilitado",
  "Recierre 79 operando",
  "Posición de interruptor",
  "Posición de seccionador barra A",
  "Posición de seccionador barra B",
  "Posición de seccionador de línea",
  "Posición de cuchilla de puesta tierra",
  "Comando de interruptor",
  "Comando de seccionador barra A",
  "Comando de seccionador barra B",
  "Comando de seccionador de línea",
  "Enclavamiento de cierre interruptor",
  "Enclavamiento de apertura interruptor",
  "Enclavamiento de cierre seccionador barra A",
  "Enclavamiento de apertura seccionador barra A",
  "Enclavamiento de cierre seccionador barra B",
  "Enclavamiento de apertura seccionador barra B",
  "Enclavamiento de cierre seccionador línea",
  "Enclavamiento de apertura seccionador línea",
  "Falla circuito de disparo 1",
  "Falla circuito de disparo 2",
  "Falla sincronismo 25",
  "Falla sincronización de tiempo",
  "Falla comunicación canal A",
  "Falla comunicación canal B",
  "Corriente de fase A",
  "Corriente de fase B",
  "Corriente de fase C",
  "Tensión de línea AB",
  "Tensión de línea BC",
  "Tensión de línea CA",
  "Tensión de fase A",
  "Tensión de fase B",
  "Tensión de fase C",
  "Potencia activa trifásica",
  "Potencia reactiva trifásica",
  "Potencia aparente trifásica",
  "Factor de potencia trifásico",
];

// Señales clasificadas por función ANSI
const ANSI_PROTECCION    = [
  "Arranque 21 direccional",
  "Arranque 21 direccional Z1",
  "Arranque 21 direccional Z2",
  "Arranque 21 direccional Z3",
  "Arranque 25 falla de sincronismo",
  "Arranque 27 subtensión",
  "Arranque 27 subtensión barra 1",
  "Arranque 27 subtensión barra 2",
  "Arranque 27 subtensión lado 1",
  "Arranque 27 subtensión lado 2",
  "Arranque 32 potencia direccional",
  "Arranque 32 potencia direccional lado 1",
  "Arranque 32 potencia direccional lado 2",
  "Arranque 46 desbalance de corriente",
  "Arranque 59 sobretensión",
  "Arranque 59 sobretensión barra 1",
  "Arranque 59 sobretensión barra 2",
  "Arranque 59 sobretensión lado 1",
  "Arranque 59 sobretensión lado 2",
  "Arranque 67 direccional de fases",
  "Arranque 67N direccional de neutro",
  "Arranque 87B diferencial de barras",
  "Arranque 87L diferencial de línea",
  "Arranque 87T diferencial de transformador lado 1",
  "Arranque 87T diferencial de transformador lado 2",
  "Arranque de sobrecorriente temporizada 51",
  "Arranque de sobrecorriente temporizada 51 lado 1",
  "Arranque de sobrecorriente temporizada 51 lado 2",
  "Arranque de sobrecorriente temporizada de neutro 51N",
  "Arranque de sobrecorriente temporizada de neutro 51N lado 1",
  "Arranque de sobrecorriente temporizada de neutro 51N lado 2",
  "Arranque de tiempo instantánea 50",
  "Arranque de tiempo instantánea 50 lado 1",
  "Arranque de tiempo instantánea 50 lado 2",
  "Arranque de tiempo instantánea de neutro 50N",
  "Arranque de tiempo instantánea de neutro 50N lado 1",
  "Arranque de tiempo instantánea de neutro 50N lado 2",
  "Arranque general",
  "Arranque general lado 1",
  "Arranque general lado 2",
  "Arranque sobrecorriente TD 50/51",
  "Arranque sobrecorriente TD 50/51 lado 1",
  "Arranque sobrecorriente TD 50/51 lado 2",
  "Arranque sobrecorriente TD 50N/51N",
  "Arranque sobrecorriente TD 50N/51N lado 2",
  "Arranque sobrecorriente TI 50/51",
  "Arranque sobrecorriente TI 50/51 lado 1",
  "Arranque sobrecorriente TI 50/51 lado 2",
  "Arranque sobrecorriente TI 50N/51N",
  "Arranque sobrecorriente TI 50N/51N lado 1",
  "Arranque sobrecorriente TI 50N/51N lado 2",
  "Arranque sobrecorriente temporizada 51",
  "Arranque sobrecorriente temporizada de neutro 51N",
  "Arranque tiempo instantánea 50",
  "Arranque tiempo instantánea de neutro 50N",
  "Disparo 21 direccional",
  "Disparo 21 direccional Z1",
  "Disparo 21 direccional Z2",
  "Disparo 21 direccional Z3",
  "Disparo 25 falla de sincronismo (bloqueo de cierre)",
  "Disparo 27 subtensión",
  "Disparo 27 subtensión barra 1",
  "Disparo 27 subtensión barra 2",
  "Disparo 27 subtensión lado 1",
  "Disparo 27 subtensión lado 2",
  "Disparo 32 potencia direccional",
  "Disparo 32 potencia direccional lado 1",
  "Disparo 32 potencia direccional lado 2",
  "Disparo 46 desbalance de corriente",
  "Disparo 59 sobretensión",
  "Disparo 59 sobretensión barra 1",
  "Disparo 59 sobretensión barra 2",
  "Disparo 59 sobretensión lado 1",
  "Disparo 59 sobretensión lado 2",
  "Disparo 67 direccional de fases",
  "Disparo 67N direccional de neutro",
  "Disparo 87B diferencial de barras",
  "Disparo 87L diferencial de línea",
  "Disparo 87T diferencial de transformador lado 1",
  "Disparo 87T diferencial de transformador lado 2",
  "Disparo Falla interruptor etapa 1",
  "Disparo Falla interruptor etapa 2",
  "Disparo de sobrecorriente temporizada 51",
  "Disparo de sobrecorriente temporizada 51 lado 1",
  "Disparo de sobrecorriente temporizada 51N",
  "Disparo de sobrecorriente temporizada de neutro 51N lado 2",
  "Disparo de tiempo instantánea 50",
  "Disparo de tiempo instantánea 50 lado 1",
  "Disparo de tiempo instantánea 50N",
  "Disparo de tiempo instantánea de neutro 50N lado 2",
  "Disparo falla de interruptor etapa 1 (50BF)",
  "Disparo falla de interruptor etapa 2 (50BF)",
  "Disparo general",
  "Disparo general lado 1",
  "Disparo general lado 2",
  "Disparo sobrecorriente TD 50/51",
  "Disparo sobrecorriente TD 50/51 lado 1",
  "Disparo sobrecorriente TD 50/51 lado 2",
  "Disparo sobrecorriente TD 50N/51N",
  "Disparo sobrecorriente TD 50N/51N lado 2",
  "Disparo sobrecorriente TI 50/51",
  "Disparo sobrecorriente TI 50/51 lado 1",
  "Disparo sobrecorriente TI 50/51 lado 2",
  "Disparo sobrecorriente TI 50N/51N",
  "Disparo sobrecorriente TI 50N/51N lado 1",
  "Disparo sobrecorriente TI 50N/51N lado 2",
  "Disparo sobrecorriente temporizada 51",
  "Disparo sobrecorriente temporizada de neutro 51N",
  "Disparo tiempo instantánea 50",
  "Disparo tiempo instantánea de neutro 50N",
  "Falla 25 sincronismo lado 1",
  "Falla 25 sincronismo lado 2",
  "Falla 25 tiempo máximo lado 1",
  "Falla 25 tiempo máximo lado 2",
  "Falla circuito de disparo 1",
  "Falla circuito de disparo 2",
  "Falla sincronismo 25",
];
const ANSI_CONTROL       = [
  "Comando de interruptor",
  "Comando de seccionador A",
  "Comando de seccionador B",
  "Comando de seccionador de línea",
  "Comando interruptor lado 1",
  "Comando interruptor lado 2",
  "Comando seccionador lado 1",
  "Comando seccionador lado 2",
  "Enclavamiento de apertura interruptor",
  "Enclavamiento de apertura seccionador A",
  "Enclavamiento de apertura seccionador B",
  "Enclavamiento de apertura seccionador línea",
  "Enclavamiento de cierre interruptor",
  "Enclavamiento de cierre seccionador A",
  "Enclavamiento de cierre seccionador B",
  "Enclavamiento de cierre seccionador línea",
  "Posición de cuchilla de puesta a tierra",
  "Posición de cuchilla de puesta tierra",
  "Posición de interruptor",
  "Posición de interruptor lado 1",
  "Posición de interruptor lado 2",
  "Posición de seccionador A",
  "Posición de seccionador B",
  "Posición de seccionador de línea",
  "Posición de seccionador lado 1",
  "Posición de seccionador lado 2",
  "Recierre 79 habilitado",
  "Recierre 79 operando",
];
const ANSI_MEDIDA        = [
  "Arranque 81 sobrefrecuencia",
  "Arranque 81 subfrecuencia",
  "Corriente de fase A",
  "Corriente de fase A lado 1",
  "Corriente de fase A lado 2",
  "Corriente de fase B",
  "Corriente de fase B lado 1",
  "Corriente de fase B lado 2",
  "Corriente de fase C",
  "Corriente de fase C lado 1",
  "Corriente de fase C lado 2",
  "Corriente de secuencia cero",
  "Diferencia de tensión entre barras",
  "Disparo 81 sobrefrecuencia",
  "Disparo 81 subfrecuencia",
  "Factor de potencia trifásico",
  "Factor de potencia trifásico lado 1",
  "Factor de potencia trifásico lado 2",
  "Frecuencia barra 1",
  "Frecuencia barra 2",
  "Potencia activa trifásica",
  "Potencia activa trifásica lado 1",
  "Potencia activa trifásica lado 2",
  "Potencia aparente trifásica",
  "Potencia aparente trifásica lado 1",
  "Potencia aparente trifásica lado 2",
  "Potencia reactiva trifásica",
  "Potencia reactiva trifásica lado 1",
  "Potencia reactiva trifásica lado 2",
  "Tensión de fase A",
  "Tensión de fase A lado 1",
  "Tensión de fase A lado 2",
  "Tensión de fase B",
  "Tensión de fase B lado 1",
  "Tensión de fase B lado 2",
  "Tensión de fase C",
  "Tensión de fase C lado 1",
  "Tensión de fase C lado 2",
  "Tensión de línea AB",
  "Tensión de línea AB barra 1",
  "Tensión de línea AB barra 2",
  "Tensión de línea AB lado 1",
  "Tensión de línea AB lado 2",
  "Tensión de línea BC",
  "Tensión de línea BC barra 1",
  "Tensión de línea BC barra 2",
  "Tensión de línea BC lado 1",
  "Tensión de línea BC lado 2",
  "Tensión de línea CA",
  "Tensión de línea CA barra 1",
  "Tensión de línea CA barra 2",
  "Tensión de línea CA lado 1",
  "Tensión de línea CA lado 2",
];
const ANSI_COMUNICACIONES= [
  "Falla comunicación canal A",
  "Falla comunicación canal B",
  "Falla sincronización de tiempo",
  "Local remoto IED",
  "Modo prueba IED",
  "Modo simulación IED",
];

function dsLabel(ds: string): string {
  const MAP: Record<string,string> = {
    dataset_Ln1:      "Líneas",
    dataset_PTS1:     "Transformadores",
    dataset_Mt1:      "Motores",
    dataset_VI3p1:    "Alimentadores",
    dataset_620s:     "620s",
    dataset_670s:     "670s",
    dataset_G02_SEL:  "Familia 400",
    dataset_G03_SEL:  "Familia 700",
    dataset_G04_SEL:  "Familia 700",
    dataset_G08_SEL:  "Familia 400",
    dataset_G09_SEL:  "Familia 400",
    dataset_G10_SEL:  "Familia 400",
    dataset_GE:       "Familia UR",
  };
  return MAP[ds] ?? ds.replace("dataset_","");
}

// Descripción (letra pequeña) por subgrupo: referencias cubiertas por el dataset.
const DS_DESC: Record<string,string> = {
  "Familia UR": "B30 · C70 · D30 · D60 · F35 · F60 · G60 · L30 · L60 · L90 · M60 · T60",
};

function groupDatasets(
  datasets: Record<string,string[]>
): Array<{ label:string; ds:string; ieds:string[] }> {
  const grouped: Map<string,{ds:string; ieds:string[]}> = new Map();
  for (const [ds, ieds] of Object.entries(datasets)) {
    const label = dsLabel(ds);
    const existing = grouped.get(label);
    if (existing) existing.ieds.push(...ieds);
    else grouped.set(label, { ds, ieds: [...ieds] });
  }
  return Array.from(grouped.entries()).map(([label,{ds,ieds}])=>({label,ds,ieds}));
}

function BrandAccordion({ brand, datasets, selectedIed, disabled, onSelect, isOpen, onToggle }:
  { brand:string; datasets:Record<string,string[]>; selectedIed:string; disabled:boolean; onSelect:(ied:string, modelOverride?:string)=>void; isOpen:boolean; onToggle:()=>void; }) {
  const open = isOpen;
  // Vista activa (SP5 por defecto / SP4) por cada dataset con vistas duales.
  const [spView, setSpView] = useState<Record<string,"sp5"|"sp4">>({});
  const allIeds    = Object.values(datasets).flat();
  const hasSelected = allIeds.includes(selectedIed);
  const groups     = groupDatasets(datasets);
  return (
    <div className="border-b border-[var(--color-outline-variant)]">
      <button onClick={onToggle} disabled={disabled}
        className={cn("flex w-full items-center justify-between px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide transition-colors",
          disabled ? "cursor-not-allowed opacity-40" : "hover:bg-[var(--color-surface-variant)]",
          hasSelected ? "text-[var(--color-brand)]" : "text-[var(--color-on-surface-variant)]")}>
        <span>{brand}</span>
        <span className={cn("text-[10px] transition-transform", open ? "rotate-90" : "")}>▶</span>
      </button>
      {open && !disabled && (
        <div className="pb-2 pl-4 pr-2">
          {groups.map(({ label, ds, ieds }) => {
            const soloMismo = ieds.length === 1 && ieds[0] === label;
            const tieneVistas = !!SP_VIEWS[ds];               // subgrupo con SP5/SP4
            const vista = spView[ds] ?? "sp5";
            const override = tieneVistas && vista === "sp4" ? SP4_MODEL[ds] : undefined;
            return (
            <div key={label}>{/* i18n */}
              {!soloMismo && (
                <div className="py-1 text-[10px] uppercase tracking-wide text-[var(--color-on-surface-variant)] opacity-60">
                  {tr(label, useLangStore.getState().lang)}
                </div>
              )}
              {tieneVistas && (
                <div className="mb-1 flex items-center gap-1.5">
                  <span className="shrink-0 text-[10px] text-[var(--color-on-surface-variant)] opacity-70">
                    IEC61850 Structure:
                  </span>
                  {(["sp5","sp4"] as const).map(v => (
                    <button key={v}
                      onClick={() => setSpView(s => ({ ...s, [ds]: v }))}
                      className={cn("shrink-0 whitespace-nowrap rounded border px-1.5 py-px text-[10px] font-mono leading-tight transition-colors",
                        vista === v
                          ? "border-[var(--color-brand)] bg-[var(--color-brand-soft-10)] text-[var(--color-brand)]"
                          : "border-[var(--color-outline-variant)] text-[var(--color-on-surface-variant)] hover:border-[var(--color-border)]")}>
                      {v === "sp5" ? "SP5 View" : "SP4 View"}
                    </button>
                  ))}
                </div>
              )}
              {ieds.map(ied => {
                const activo = ied===selectedIed;
                return (
                <button key={ied} onClick={() => onSelect(ied, override)}
                  className={cn("mb-0.5 block w-full rounded px-2 py-1 text-left font-mono text-xs transition-colors",
                    activo
                      ? "border border-[var(--color-brand-border-60)] bg-[var(--color-brand-soft-20)] text-[var(--color-brand)]"
                      : "text-[var(--color-on-surface-variant)] hover:bg-[var(--color-brand-soft-10)] hover:text-[var(--color-on-surface)]")}>
                  {soloMismo ? tr(ied, useLangStore.getState().lang) : ied}
                  {activo && tieneVistas && (
                    <span className="ml-1 text-[9px] opacity-70">({vista === "sp4" ? "SP4" : "SP5"})</span>
                  )}
                </button>
                );
              })}
              {DS_DESC[label] && (
                <div className="px-2 pb-1 text-[10px] leading-relaxed text-[var(--color-on-surface-variant)] opacity-60">
                  {DS_DESC[label]}
                </div>
              )}
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function TipicosAccordion({ tabId, selectedIed, disabled }:
  { tabId:string; selectedIed:string; disabled:boolean; }) {
  const { lang } = useLangStore();
  const [open, setOpen]          = useState(false);
  const [selTipico, setSelTipico] = useState<string|null>(null);
  const [loading, setLoading]    = useState(false);
  const { runInference, setTab, getTab } = useNbStore();

  const tipicos = [
    { id:"linea",         label:"Bahía de línea",           signals:BAHIA_LINEA         },
    { id:"acople",        label:"Bahía de acople",          signals:BAHIA_ACOPLE        },
    { id:"transformador", label:"Bahía de transformador",   signals:BAHIA_TRANSFORMADOR },
    { id:"alimentador",   label:"Circuito alimentador",     signals:BAHIA_ALIMENTADOR   },
  ];

  const handleSelect = async (tipId: string, signals: string[]) => {
    setSelTipico(tipId);
    if (!selectedIed) {
      alert(tr("Selecciona primero un IED en la pestaña Lista de IEDs", lang));
      return;
    }
    setLoading(true);
    try {
      await runInference(tabId, signals.map(s => tr(s, lang)), selectedIed);
      // Actualizar título de pestaña con el tipo de bahía seleccionado
      const tipico = tipicos.find(t => t.id === tipId);
      try { usePagesStore.getState().rename(tabId, `${tr(tipico?.label ?? "Típicos", lang)} — ${selectedIed}`); } catch(_) {/**/}
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border-b border-[var(--color-outline-variant)]">
      <button onClick={() => setOpen(!open)}
        className={cn("flex w-full items-center justify-between px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide transition-colors",
          "hover:bg-[var(--color-surface-variant)] text-[var(--color-on-surface-variant)]")}>
        <span>{tr("Típicos de bahía",lang)}</span>
        <span className={cn("text-[10px] transition-transform", open ? "rotate-90" : "")}>▶</span>
      </button>
      {open && (
        <div className="pb-2 pl-3 pr-2 space-y-1">
          {!selectedIed && (
            <p className="text-[10px] text-[var(--color-status-absent)] px-2 py-1">
              {tr('⚠ Selecciona un IED en "Lista de IEDs" para cargar señales con inferencia.',lang)}
            </p>
          )}
          {tipicos.map(t => (
            <button key={t.id} onClick={() => void handleSelect(t.id, t.signals)}
              disabled={loading}
              className={cn("block w-full rounded px-2 py-1.5 text-left text-xs transition-colors",
                selTipico === t.id
                  ? "border border-[var(--color-brand-border-60)] bg-[var(--color-brand-soft-20)] text-[var(--color-brand)]"
                  : "text-[var(--color-on-surface-variant)] hover:bg-[var(--color-brand-soft-10)]")}>
              {tr(t.label,lang)}
              <span className="ml-1 text-[10px] opacity-60">{t.signals.length} {tr("señales",lang)}</span>
            </button>
          ))}
          {loading && <p className="text-[10px] text-[var(--color-brand)] px-2 animate-pulse">{tr("Infiriendo nodos MMS…",lang)}</p>}
        </div>
      )}
    </div>
  );
}

// Acordeón de función ANSI — señales individuales seleccionables
function FuncionAccordion({ tabId, selectedIed, label, signals }: {
  tabId: string; selectedIed: string; label: string; signals: string[];
}) {
  const [open, setOpen]         = useState(false);
  const { lang } = useLangStore();
  const [loading, setLoading]   = useState<string|null>(null);
  const [filter, setFilter]     = useState("");
  const { runInference, getTab, setTab } = useNbStore();
  // Filtrar señales por texto (sin tildes, case-insensitive)
  const norm = (s:string) => s.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase();
  const filtered = filter.trim()
    ? signals.filter(s => norm(tr(s,lang)).includes(norm(filter)))
    : signals;

  const handleSignal = async (signal: string) => {
    if (!selectedIed) {
      alert(tr("Selecciona primero un IED en la pestaña Lista de IEDs", lang));
      return;
    }
    setLoading(signal);
    try {
      // Insertar la señal inferida al final de las filas existentes
      const { rows: existingRows, sclNodes } = getTab(tabId);
      const { predictBatch, validateInScl } = await import("../../wasm/client");
      const [newRow] = await predictBatch([signal], selectedIed);
      const finalRow = sclNodes.length
        ? (await validateInScl([newRow], sclNodes))[0]
        : newRow;
      setTab(tabId, { rows: [...existingRows, finalRow] });
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="border-b border-[var(--color-outline-variant)]">
      <button onClick={() => setOpen(!open)}
        className={cn(
          "flex w-full items-center justify-between px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide transition-colors",
          "hover:bg-[var(--color-surface-variant)] text-[var(--color-on-surface-variant)]"
        )}>
        <span>{label}</span>
        <span className={cn("text-[10px] transition-transform", open ? "rotate-90" : "")}>▶</span>
      </button>
      {open && (
        <div className="max-h-72 overflow-y-auto pb-2">
          {/* Cajita de filtro en el encabezado de la lista */}
          <div className="sticky top-0 z-10 bg-[var(--color-surface-container-low)] px-3 py-2">
            <input
              type="text"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              placeholder={tr("Filtrar funciones…",lang)}
              className={cn(
                "w-full rounded border border-[var(--color-outline-variant)] bg-[var(--color-surface)]",
                "px-2 py-1 text-[11px] text-[var(--color-on-surface)] outline-none",
                "placeholder:text-[var(--color-on-surface-variant)]",
                "focus:border-[var(--color-brand)]"
              )}
            />
          </div>
          {!selectedIed && (
            <p className="text-[10px] text-[var(--color-status-absent)] px-4 py-1">
              {tr('⚠ Selecciona un IED en "Lista de IEDs" primero.',lang)}
            </p>
          )}
          {filtered.length === 0 && (
            <p className="text-[10px] text-[var(--color-on-surface-variant)] px-4 py-1 opacity-60">
              {tr("Sin coincidencias para",lang)} "{filter}"
            </p>
          )}
          {filtered.map((sig, i) => (
            <button
              key={i}
              onClick={() => void handleSignal(tr(sig,lang))}
              disabled={loading !== null}
              className={cn(
                "flex w-full items-center justify-between px-4 py-1 text-left text-[11px] transition-colors",
                loading === tr(sig,lang)
                  ? "text-[var(--color-brand)] animate-pulse"
                  : "text-[var(--color-on-surface-variant)] hover:bg-[var(--color-brand-soft-10)] hover:text-[var(--color-on-surface)]"
              )}>
              <span className="truncate pr-2">{tr(sig,lang)}</span>
              {loading === sig
                ? <span className="shrink-0 text-[9px]">…</span>
                : <span className="shrink-0 text-[10px] opacity-40">+</span>
              }
            </button>
          ))}
        </div>
      )}
    </div>
  );
}


export function IedPanel({ tabId, sclDisabled }: { tabId:string; sclDisabled:boolean }) {
  const { lang } = useLangStore();
  const [tab, setTab]             = useState<"ieds"|"tipicos">("ieds");
  // Modo "Mapear a SCL": la marca ya está fijada desde el landing -> panel bloqueado
  const brandLock = useNbStore(s => !!s.getTab(tabId).mapBrandLock);
  const [openBrand, setOpenBrand] = useState<string|null>(null);  // acordeón abierto (exclusivo)
  const { getTab, reInferForIed } = useNbStore();
  const { selectedIed } = getTab(tabId);
  return (
    <div className="flex h-full flex-col bg-[var(--color-surface-container-low)]">
      <div className="flex shrink-0 border-b border-[var(--color-border)]">
        {(["ieds","tipicos"] as const).map(t => (
          <button key={t} onClick={() => setTab(t)} disabled={brandLock}
            title={brandLock ? tr("No disponible en modo Mapear a SCL",lang) : ""}
            data-tutorial={t === "ieds" ? "ied-list" : "typicals"}
            className={cn("flex-1 py-2 text-[11px] font-medium uppercase tracking-wide transition-colors",
              tab===t ? "border-b-2 border-[var(--color-brand)] text-[var(--color-brand)]"
                      : "text-[var(--color-on-surface-variant)] hover:bg-[var(--color-surface-variant)]")}>
            {t==="ieds" ? tr("Lista de IEDs",lang) : tr("Catálogo de típicos",lang)}
          </button>
        ))}
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        {brandLock && (
          <p className="p-3 text-[11px] leading-relaxed text-[var(--color-on-surface-variant)] opacity-70">
            {tr("La marca se fijó al entrar por Mapear a SCL. La selección de referencia no es necesaria.",lang)}
          </p>
        )}
        {!brandLock && tab==="ieds" && Object.entries(IED_CATALOG).map(([brand,datasets]) => (
          <BrandAccordion key={brand} brand={brand} datasets={datasets}
            selectedIed={selectedIed} disabled={sclDisabled}
            isOpen={openBrand===brand}
            onToggle={() => setOpenBrand(openBrand===brand ? null : brand)}
            onSelect={(ied, override) => void reInferForIed(tabId, ied, override)} />
        ))}
        {!brandLock && tab==="tipicos" && (
          <>
            <TipicosAccordion tabId={tabId} selectedIed={selectedIed} disabled={false} />
            <FuncionAccordion tabId={tabId} selectedIed={selectedIed}
              label={tr("FUNCIONES DE PROTECCIÓN",lang)}    signals={ANSI_PROTECCION} />
            <FuncionAccordion tabId={tabId} selectedIed={selectedIed}
              label={tr("FUNCIONES DE CONTROL",lang)}       signals={ANSI_CONTROL} />
            <FuncionAccordion tabId={tabId} selectedIed={selectedIed}
              label={tr("FUNCIONES DE MEDIDA",lang)}        signals={ANSI_MEDIDA} />
            <FuncionAccordion tabId={tabId} selectedIed={selectedIed}
              label={tr("FUNCIONES DE COMUNICACIÓN",lang)}  signals={ANSI_COMUNICACIONES} />
          </>
        )}
      </div>
    </div>
  );
}
